// extracted by mini-css-extract-plugin
export default {"SliderContainer":"style_SliderContainer__Q4BoV","SliderImage":"style_SliderImage__bfMWw","SliderSlide":"style_SliderSlide__T98Bl","Current":"style_Current__qqMSs"};